module.exports = ".button-group{\n    position: fixed;\n    top:10px;\n    right:10px;\n    width: 50px;\n    z-index:1;\n}"